module.exports = __webpack_public_path__ + "img/client4.bc5fddb4.png";